<template>
  <div class="order-list">
    <div :class="{ 'bg-head-nav': true, 'bg-head-h187': isBgHeaderH187 }"></div>
    <div class=" order-list-main">
      <div class="controller-container">
        <div class="controller-content">
          <el-input v-model="contract_num" placeholder="合同号"></el-input>
          <el-input v-model="order_num" placeholder="订单号"></el-input>
          <span class="orderConfirmDate">订单确认时间:</span>
          <el-date-picker
            v-model="order_confirm_date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button class="action-select-inventory" @click="uploadFile"
            >上传</el-button
          >
          <el-button type="primary" class="search" @click="serach"
            >搜索</el-button
          >
          <el-button type="success" class="down" @click="down">导出</el-button>
        </div>
      </div>
      <div class="table-container table-container1">
        <!-- <span v-if="checkStatusRadio" class="table-select-all">全选</span> -->
        <el-table
          @selection-change="selectAllOrder"
          :header-cell-style="changeTableHeaderStyle"
          :cell-style="changeTableStyle"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            prop="contract_num"
            label="合同单号"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="order_num"
            label="订单号"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="supplier"
            label="供应商"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="explain"
            label="说明"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="document_date"
            label="凭证日期"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="order_confirm_date"
            label="订单确认日期"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="required_delivery_date"
            label="要求发货日期"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="order_status"
            label="订单状态"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="material_code"
            label="物料编码"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="material_describe"
            label="物料描述"
            align="center"
            width="150"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="planned_quantity"
            label="计划量"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="order_unit"
            label="订单单位"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="brand" label="品牌" align="center" width="80">
          </el-table-column>
          <el-table-column prop="specs" label="规格" align="center" width="80">
          </el-table-column>
          <el-table-column
            prop="kilogram"
            label="公斤数(吨)"
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            prop="receiving_unit"
            label="收货单位"
            align="center"
            width="150"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="receiving_people"
            label="收货人"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="contact_number"
            label="联系电话"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="receiving_address"
            label="收货地址"
            align="center"
            width="150"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="flow_direction"
            label="流向"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="destination"
            label="到站"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            width="80"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="order_payment_status"
            label="销售订单货款确认情况"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="acceptance_check_num"
            label="验收量（吨）"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="accepted_unsettled"
            label="已验收待结算量（吨）"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="contract_life"
            label="合同有效期"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="acceptance_check_bill"
            label="验收单"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="seeSignReceipt(scope.row, 'Acceptance')"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="acceptance_check_remark"
            label="验收备注"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column label="签认单" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="seeSignReceipt(scope.row, 'SignReceipt')"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="settlement_num"
            label="结算量"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="settlement_date"
            label="结算日期"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="settlement_status"
            label="结算状态"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleEidtList(scope.row, 'check')"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="deleteEidtList(scope.row, 'check')"
                v-if="userTypeNum == -1"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total,prev,pager,next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="上传表格" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="" :label-width="formLabelWidth">
          <!-- https://xarh.sprucesmart.com/api/v1/create_station_order -->
          <el-upload
            ref="upload"
            class="upload-demo"
            action="https://xarh.sprucesmart.com/api/v3/upload_order"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :limit="1"
            name="order_excel"
            :auto-upload="false"
            :on-error="upLoadFileFail"
            :on-success="upLoadFileSuccess"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpload">上传服务器</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="dialogItem">
        <span class="dialogText">合同号:</span>
        <el-input v-model="contractNum"></el-input>
      </div>
      <div class="dialogItem">
        <span class="dialogText">销售订单货款确认情况:</span>
        <el-input v-model="orderPaymentStatus"></el-input>
      </div>
      <div class="dialogItem">
        <span class="dialogText">结算量(吨)</span>
        <el-input v-model="settlement_num" type="number"></el-input>
      </div>
      <div>
        <span class="dialogText">结算日期</span>
        <el-input v-model="settlement_date"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleEdit">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片弹窗 -->
    <el-dialog
      title="图片"
      :visible.sync="imgListDisplay"
      @close="handImgCancle"
    >
      <div
        v-for="(item, index) in imgList"
        :key="index"
        class="acceptanceImgBox"
      >
        <img :src="item" alt="" class="acceptanceImg" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Tool from "../../assets/js/Tool.js";
import Cookie from "js-cookie";
import moment from "moment";
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      isHide: true,
      isBgHeaderH187: false,
      checkStatusRadio: 0,
      style: "",
      tableData: [],
      currentWarehouse_id: "",
      oneLevelInventoryArr: [],
      twoLevelInventoryArr: [],
      oneLevelInventory: [],
      twoLevelInventory: [],
      fileList: [],
      orderIdArr: [],
      dialogFormVisible: false,
      formLabelWidth: "120px",
      show: false,
      page: 1, //第几页
      pageSize: 10, //一页10条
      currentPage: 1, //当前页
      total: 0,
      contract_num: "", //合同号
      order_num: "", //订单号
      order_confirm_date: [], //订单确认日期
      start_order_confirm_date: "",
      end_order_confirm_date: "",
      dialogVisible: false,
      contractNum: "", //合同号
      orderPaymentStatus: "", //销售订单贷款确认情况
      order_id: "",
      settlement_num: "", //结算量
      settlement_date: "", //结算日期
      imgListDisplay: false,
      imgList: [], //
    };
  },
  computed: {
    ...mapGetters(["user", "userTypeNum"]),
  },
  created() {
    this.init(
      this.page,
      this.pageSize,
      this.order_num,
      this.contract_num,
      this.start_order_confirm_date,
      this.end_order_confirm_date
    );
    console.log("this.user_type_num: ", this.userTypeNum);
  },
  methods: {
    // 删除
    async deleteEidtList(row) {
      const deleteData = await this.axios.post(
        this.axios.defaults.baseURL1 + "delete_order_info",
        qs.stringify({
          order_id: row.order_id,
        })
      );
      if (deleteData.data.errno == 0) {
        this.$message.success(deleteData.data.results.msg);
        this.init(
          this.page,
          this.pageSize,
          this.order_num,
          this.contract_num,
          this.start_order_confirm_date,
          this.end_order_confirm_date
        );
      }
    },
    handImgCancle() {
      this.imgListDisplay = false;
    },
    // 签认单
    seeSignReceipt(row, value) {
      if (value == "SignReceipt") {
        this.imgListDisplay = true;
        this.imgList = row.sign_receipt;
      } else {
        this.imgListDisplay = true;
        this.imgList = row.acceptance_check_bill;
      }
    },
    // 导出
    down() {
      window.location.href = this.axios.defaults.baseURL1 + "download_order";
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.settlement_num = "";
      this.settlement_date = "";
    },
    async submitEdit() {
      if (
        (this.settlement_num == "" && this.settlement_date == "") ||
        (this.settlement_num && this.settlement_date)
      ) {
        const editData = await this.axios.post(
          this.axios.defaults.baseURL1 + "update_order_info",
          qs.stringify({
            order_id: this.order_id,
            order_payment_status: this.orderPaymentStatus,
            contract_num: this.contractNum,
            settlement_num: this.settlement_num,
            settlement_date: this.settlement_date,
          })
        );
        console.log("editData", editData);
        if (editData.data.errno == 0) {
          this.$message.success(editData.data.results.msg);
          this.dialogVisible = false;
          this.orderPaymentStatus = "";
          this.contractNum = "";
          this.settlement_num = "";
          this.settlement_date = "";
          this.init(
            this.page,
            this.pageSize,
            this.order_num,
            this.contract_num,
            this.start_order_confirm_date,
            this.end_order_confirm_date
          );
        } else {
          this.$message.error(editData.data.results.msg);
        }
      } else {
        //  判断是结算量还是结算日期为空
        if (this.settlement_num == "") {
          this.$message.error("结算量不能为空");
        } else if (this.settlement_date == "") {
          this.$message.error("结算日期不能为空");
        }
      }
    },
    cancleEdit() {
      this.dialogVisible = false;
      this.orderPaymentStatus = "";
      this.contractNum = "";
      this.settlement_num = "";
      this.settlement_date = "";
    },
    async handleEidtList(row) {
      console.log("row", row);
      this.dialogVisible = true;
      this.order_id = row.order_id;
      this.settlement_num = row.settlement_num;
      this.settlement_date = row.settlement_date;
    },
    changeTableHeaderStyle({ row, rowIndex }) {
      return "color:black; font-weight: bold;";
    },
    changeTableStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 4) {
        if (row.status_num == -1) {
          return "color: #FF3333;";
        } else if (row.status_num == 0) {
          return "color: #29bd7f;";
        } else if (row.status_num == 1) {
          return "color: #e6a23c;";
        }
      }
      return "color: #000;";
    },
    async init(
      page,
      pageSize,
      order_num,
      contract_num,
      start_order_confirm_date,
      end_order_confirm_date
    ) {
      const tableData = await this.axios.get(
        this.axios.defaults.baseURL1 +
          "get_order_list?page=" +
          page +
          "&psize=" +
          pageSize +
          "&order_num=" +
          order_num +
          "&contract_num=" +
          contract_num +
          "&start_order_confirm_date=" +
          start_order_confirm_date +
          "&end_order_confirm_date=" +
          end_order_confirm_date
      );
      console.log("tableData", tableData);
      if (tableData.data.errno === 0) {
        this.tableData = tableData.data.results.data;
        this.total = tableData.data.results.pager.total;
      } else {
        this.$message.error(tableData.data.results.msg);
      }
    },
    handleCurrentChange(currentPage) {
      this.page = currentPage;
      this.init(
        this.page,
        this.pageSize,
        this.order_num,
        this.contract_num,
        this.start_order_confirm_date,
        this.end_order_confirm_date
      );
    },
    serach() {
      this.page = 1;
      if (this.order_confirm_date && this.order_confirm_date.length > 0) {
        this.start_order_confirm_date = moment(
          this.order_confirm_date[0]
        ).format("YYYY-MM-DD");
        this.end_order_confirm_date = moment(this.order_confirm_date[1]).format(
          "YYYY-MM-DD"
        );
      } else {
        this.start_order_confirm_date = "";
        this.end_order_confirm_date = "";
      }
      this.init(
        this.page,
        this.pageSize,
        this.order_num,
        this.contract_num,
        this.start_order_confirm_date,
        this.end_order_confirm_date
      );
    },
    // 手动上传文件到服务器
    submitUpload() {
      console.log("手动上传文件到服务器");
      this.$refs.upload.submit();
    },
    upLoadFileFail(response, file, fileList) {
      console.log("response: ", response);
      console.log("file: ", file);
      console.log("fileList: ", fileList);
      this.dialogFormVisible = false;
      this.$message({
        type: "success",
        message: "上传文件失败!",
      });
    },
    // 上传文件成功
    async upLoadFileSuccess(response, file, fileList) {
      console.log("response: ", response);
      if (response.errno == 0) {
        console.log("上传文件成功");
        this.dialogFormVisible = false;
        this.fileList = [];
        this.$message({
          type: "success",
          message: response.results.msg,
        });
      } else {
        this.$message({
          type: "error",
          message: response.results.msg,
        });
      }
      //调列表
      this.init(
        this.page,
        this.pageSize,
        this.order_num,
        this.contract_num,
        this.start_order_confirm_date,
        this.end_order_confirm_date
      );
    },
    handleRemove(file, fileList) {
      console.log("删除文件");
      console.log(file, fileList);
    },
    handleExceed(files, fileList) {
      console.log("handleExceed");
      // `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handlePreview(file) {
      console.log("handlePreview");
      console.log("=======", file);
    },
    selectAllOrder(val) {
      console.log("选中的item： ", val);
      if (val.length == 0) {
        this.orderIdArr = [];
      } else {
        this.orderIdArr = [];
        val.forEach((item) => {
          this.orderIdArr.push(item.id);
        });
      }
      console.log("orderIdArr: ", this.orderIdArr);
    },
    //上传
    uploadFile() {
      this.dialogFormVisible = true;
    },
  },
};
</script>

<style scoped>
@import url(../../assets/css/base.css);

.order-list-main {
  position: relative;
  top: -63px;
  background-color: transparent;
  margin: 10px auto;
}
.el-input {
  width: 180px;
  margin-left: 20px;
}
.search {
  /* margin-left: 30px; */
}
.orderConfirmDate {
  font-size: 14px;
  font-weight: bold;
  margin-left: 20px;
}
.action-select-first,
.action-select-inventory {
  margin-left: 24px;
  /* width: 133px; */
}

.action-select-first {
  margin-left: 0px;
}

.table-container {
  position: relative;
  padding: 0 20px;
  /* background: pink; */
}

.el-pagination {
  margin: 10px;
  /* position: absolute;
  right: 0px; */
}
.table-select-all {
  position: absolute;
  left: 55px;
  top: 13px;
  color: #888;
  z-index: 100;
}

.bg-head-nav {
  background-color: #d2f5e8;
  height: 64px;
}

.bg-head-h187 {
  height: 187px;
}
.dialogItem {
  margin-bottom: 20px;
}
.dialogText {
  display: inline-block;
  width: 150px;
  text-align: right;
}

/* 导出 */
.down {
  /* margin-left: 30px; */
  /* float: right; */
  /* margin-right: 30px; */
}

.img {
  width: 300px;
  height: 500px;
  overflow-y: scroll;
  /* background: pink; */
}
/* 验收单图片弹窗 */
.acceptanceImgBox {
  margin-bottom: 20px;
  text-align: center;
}
.acceptanceImg {
   /* object-fit: contain;
   width: 500px;
   height: 300px; */
   max-width: 100%;
    height: auto;
}

</style>
<style>
.table-container1 .el-table td,
.el-table th {
  padding: 8px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/orderInSystem.vue